import api from "@/api";
const LIMIT = 12; // must be multiple of 2 and 3

let previousCategoryId = 0;
let end = false;
let page = 1;

const state = () => ({
  order: { display: "Alphabetical", value: "alphabetical" },
  products: [],
  pending: false,
});

const noProducts = (data) => {
  return page === 1 && !data.length;
};

const actions = {
  async fetch({ commit, dispatch, state }, categoryId) {
    const newCategory = previousCategoryId !== categoryId;

    if (newCategory) {
      end = false;
      page = 1;
      previousCategoryId = categoryId;
      commit("RESET_PRODUCTS");
      commit("PENDING", true);
    } else {
      if (end) {
        return;
      }
    }

    let params;

    if (state.order.value === "popularity") {
      params = { order: "popularity", direction: "desc" };
    } else {
      params = { order: "name", direction: "asc" };
    }

    const data = await api({
      params: {
        limit: LIMIT,
        page,
        sortby: params.order,
        sortdir: params.direction,
      },
      url: `/123/categories/${categoryId}/products`,
    });

    commit("PENDING", false);
    /*
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info); */
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : noProducts(data.info)
      ? commit(
          "notification/SHOW",
          "Sorry products didn't load. Please refresh the page.",
          { root: true }
        )
      : commit("UPDATE", data.info);
  },
  async restartFetch({ commit, dispatch, state }, categoryId) {
    end = false;
    page = 1;
    previousCategoryId = categoryId;
    commit("RESET_PRODUCTS");
    commit("PENDING", true);

    let params;

    if (state.order.value === "popularity") {
      params = { order: "popularity", direction: "desc" };
    } else {
      params = { order: "name", direction: "asc" };
    }

    const data = await api({
      params: {
        limit: LIMIT,
        page,
        sortby: params.order,
        sortdir: params.direction,
      },
      url: `/123/categories/${categoryId}/products`,
    });

    commit("PENDING", false);
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : noProducts(data.info)
      ? commit(
          "notification/SHOW",
          "Sorry products didn't load. Please refresh the page.",
          { root: true }
        )
      : commit("UPDATE", data.info);
  },
};

const getters = {
  loaded({ pending }) {
    return !pending;
  },
};

const mutations = {
  CHANGE_SORT_ORDER(state, order) {
    state.order = order;
  },
  PENDING(state, pending) {
    state.pending = pending;
  },
  RESET_PRODUCTS(state) {
    state.products = [];
  },
  UPDATE(state, products) {
    /*
    if (!state.products.length && !products.length && end !== true) {
      state.empty = true;
    }
    */
    // if (products.length <= LIMIT - 1) {
    if (!products.length) {
      end = true;
    }
    state.products = state.products.concat(products);
  },
  UPDATE_PAGE() {
    page = ++page;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
